import React, {useEffect, useState} from 'react';
import {requestCandidateGroups, requestDeleteGroup} from "@app/services/CandidateGroupService";
import {toast} from "react-toastify";
import {CANDIDATE_GROUP_ORDER_BY, DEFAULT_PAGE_SIZE} from "@app/constants/Common";
import UpdateCandidateGroupModal from "@pages/savedlist/UpdateCandidateGroupModal";
import {SavedListTabs} from "@pages/savedlist/common/Constant";
import {stringToArray} from "@app/utils/CommonUtils";
import {callApiSearchSavedList} from "@pages/savedlist/common/Services";
import TableListPaging from "@app/components/TableListPaging";

const SavedList = (props) => {
    const [candidateGroups, setCandidateGroups] = useState([]);
    const [orderBy, setOrderBy] = useState(CANDIDATE_GROUP_ORDER_BY.AZ);
    const [currentPage, setCurrentPage] = useState(1);
    const [isLoading, setIsLoading] = useState(false);
    const [selectGroup, setSelectGroup] = useState(null);
    const [showUpdateGroupInfoModal, setShowUpdateGroupInfoModal] = useState(false);
    const [savedListTab, setSavedListTab] = useState({});
    const [quickSearchConditions, setQuickSearchConditions] = useState({});
    const [totalCount, setTotalCount] = useState(0);
    const [numberPages, setNumberPages] = useState(1);

    const {tab, quickSearchInput} = props

    const searchCandidateGroups = async (page, newOrderBy, activeTab, quickSearch) => {
        setOrderBy(newOrderBy)
        setCurrentPage(page)
        setIsLoading(true)

        let params = {search_conditions: {page: page, size: 10, order_by: newOrderBy, tabs: [activeTab.id]}}
        if (quickSearch) {
            params.search_conditions = {...params.search_conditions, ...quickSearch}
        } else {
            params.search_conditions = {...params.search_conditions, ...quickSearchConditions}
        }

        await callApiSearchSavedList(params, (res) => {
            setIsLoading(false)
            const resContent = res.content
            setTotalCount(resContent.total_count)
            setCandidateGroups(resContent.saved_list);
            setNumberPages(Math.ceil(resContent.total_count/DEFAULT_PAGE_SIZE))
        });
    }

    useEffect(async () => {
        setSavedListTab(tab)
        if (quickSearchInput) {
            setQuickSearchConditions(quickSearchInput)
        }
        await searchCandidateGroups(currentPage, orderBy, tab, quickSearchInput)
    }, [tab, quickSearchInput]);

    const onChangeOrderBy = async (event) => {
        setOrderBy(event.target.value)
        await searchCandidateGroups(currentPage, event.target.value, savedListTab)
    }

    const onCloseUpdateGroupInfoModal = async (isSuccess) => {
        setShowUpdateGroupInfoModal(false)
        if (isSuccess === true) {
            toast.success(`Cập nhật thông tin saved list thành công.`);
            await searchCandidateGroups(currentPage, orderBy, savedListTab)
        } else if (isSuccess === false) {
            toast.error(`Cập nhật thông tin saved list thất bại.`);
        }
    }

    const onDeleteGroup = (groupId) => {
        let text = "Bạn chắc chắn muốn xóa saved list này?";
        if (window.confirm(text) === true) {
            setIsLoading(true)
            requestDeleteGroup({id: groupId}).then((res) => {
                searchCandidateGroups(currentPage, orderBy)
                toast.success("Xóa saved list thành công!")
            }).catch((error) => {
                console.log(`Error:${JSON.stringify(error)}`);
            }).finally(() => {
                setIsLoading(false)
            });
        }
    }

    const namePadding = (group) => {
        if (group.level === 2) {
            return 35
        }

        if (group.level === 3) {
            return 55
        }

        if (group.level === 4) {
            return 75
        }

        return 15
    }
    const nextPage = async () => {
        let currPage = currentPage + 1
        if (currPage <= numberPages) {
            quickSearchConditions.page = currPage
            await searchCandidateGroups(currentPage, orderBy, savedListTab, quickSearchConditions)
        } else {
            currPage = numberPages
        }
        setCurrentPage(currPage)
    };

    const backPage = async () => {
        let currPage = currentPage - 1
        if (currPage > 0) {
            quickSearchConditions.page = currPage
            await searchCandidateGroups(currentPage, orderBy, savedListTab, quickSearchConditions)
        } else {
            currPage = 0
        }
        setCurrentPage(currPage)
    };



    return (
        <div className="container-fluid">
            <div className="card card-default">
                <div className="card-header">
                    <h3 className="card-title text-bold">{savedListTab.title} ({totalCount})</h3>
                    {totalCount > 0 &&
                    <h3 className='card-title text-bold ml-3'>Page: {currentPage}/{numberPages}</h3>
                    }
                    <div className={'card-tools'}>
                        {totalCount > 0 &&
                        <select className='ml-3'
                                style={{
                                    padding: '0.375rem 0.75rem', backgroundColor: '#fff', border: '1px solid #ced4da',
                                    borderRadius: '0.25rem',
                                    boxShadow: 'inset 0 0 0 transparent',
                                    transition: 'border-color .15s ease-in-out,box-shadow .15s ease-in-out'
                                }}
                                name={'order_by'}
                                value={orderBy}
                                onChange={event => onChangeOrderBy(event)}>
                            <option value='1'>Cập nhật mới hơn trước</option>
                            <option value='2'>Cập nhật cũ hơn trước</option>
                            <option value='3'>Sắp xếp theo tên A-Z</option>
                            <option value='4'>Sắp xếp theo tên Z-A</option>
                        </select>
                        }
                        {numberPages > 1 &&
                        <TableListPaging onBack={backPage} onNext={nextPage}/>
                        }
                    </div>
                    {isLoading &&
                    <div className={'col-sm-12 text-center'}
                         style={{position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)'}}>
                        <div className='spinner-grow text-primary' role='status'>
                            <span className='sr-only'>Loading...</span>
                        </div>
                    </div>
                    }
                </div>
                <div className="card-body p-0">
                    <table
                        className='table table-hover table-bordered text-nowrap'
                        // style={{maxHeight: '80vh', overflow: 'scroll'}}
                    >
                        <thead>
                        <tr>
                            <th>No.</th>
                            <th>ID</th>
                            <th>Tên</th>
                            <th>Số person</th>
                            <th>Ngày tạo</th>
                            <th>Ngày cập nhật mới nhất</th>
                            <th>Notes</th>
                            <th>Hành động</th>
                        </tr>
                        </thead>
                        <tbody>
                        {candidateGroups && candidateGroups.length > 0 && candidateGroups.map((group, index) => (
                            <tr key={`candidate_${index}`}>
                                <td className={'text-center'}>{(currentPage - 1) * DEFAULT_PAGE_SIZE + index + 1}</td>
                                <td className={'text-center'}>{group.id}</td>
                                <td style={{paddingLeft: namePadding(group)}}><b>{group.name}</b></td>
                                <td className={'text-center'}>{stringToArray(group.candidate_ids).length}</td>
                                <td>{group.created_date_time}</td>
                                <td>{group.updated_date_time}</td>
                                <td>{group.notes}</td>
                                <td>
                                    <a href={`#`}
                                       onClick={() => {
                                           setSelectGroup(group)
                                           setShowUpdateGroupInfoModal(true)
                                       }}
                                       className={'btn btn-info mr-2 btn-small'}>
                                        Edit
                                    </a>
                                    <a href={`/candidate/list?groupId=${group.id}`}
                                       target={'_blank'}
                                       rel="noopener noreferrer"
                                       className={'btn btn-default mr-2'}>
                                        Xem
                                    </a>

                                    <a href={`#`}
                                       onClick={() => {
                                           setSelectGroup(group)
                                           onDeleteGroup(group.id)
                                       }}
                                       className={'btn btn-danger'}>
                                        Xoá
                                    </a>
                                </td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                </div>
            </div>
            <UpdateCandidateGroupModal isShow={showUpdateGroupInfoModal}
                                      groupInfo={selectGroup}
                                      onClose={(isSuccess) => onCloseUpdateGroupInfoModal(isSuccess)}
            />
        </div>
    );
};

export default SavedList;
